import { useState, type ReactElement } from 'react';
import type { PostFormatDto } from '@gr/core/content/posts/dto';
import { useT } from '../../../../app/di';
import { Markdown } from '../../../../ui-kit/Markdown/Markdown';
import styles from './PostFormatRules.module.scss';

export interface PostFormatRulesProps {
  /** Действующее правило поста; null — у блога нет правил. */
  format: PostFormatDto | null;
  /** Правило не выбрано, действует правило по умолчанию. */
  byDefault: boolean;
}

/** POST-UC-11: текст действующего правила оформления — раскрывается рядом с редактором поста. */
export function PostFormatRules({ format, byDefault }: PostFormatRulesProps): ReactElement {
  const { t } = useT();
  const [open, setOpen] = useState(false);
  if (!format) return <p className="u-muted u-small">{t('posts.formatRules.none')}</p>;
  return (
    <details className={styles.rules} onToggle={(event) => setOpen(event.currentTarget.open)}>
      <summary className={styles.summary}>{t(byDefault ? 'posts.formatRules.showDefault' : 'posts.formatRules.show', { name: format.name })}</summary>
      {open ? (
        <div className={styles.body}>
          <Markdown text={format.rules} empty={t('posts.formats.emptyRules')} />
        </div>
      ) : null}
    </details>
  );
}
